<!--
<div class="mat-elevation-z8">
  -->

<span #fPazienteSpan class="app-paziente-span"></span>

<div class="app-table-wrapper">
  <table mat-table class="full-width-table" matSort aria-label="Elements">

    <ng-container matColumnDef="descReferto">
      <th mat-header-cell *matHeaderCellDef>Referti trovati</th>
      <td mat-cell *matCellDef="let row" [ngClass.xs]="'app-xs-font-size'">{{getDescReferto(row)}}</td>
    </ng-container>

    <ng-container matColumnDef="btn1">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <div fxLayout="row" fxLayout.lt-md="column">
          <button mat-raised-button color="primary" (click)="onButtonReferto(row)"
                  [ngClass]="'app-margin-hor'" [ngClass.lt-md]="'app-margin-vert'"> REFERTO </button>
          <button mat-raised-button color="primary" (click)="onButtonImmagini(row)"
                  [ngClass]="'app-margin-hor'" [ngClass.lt-md]="'app-margin-vert'" *ngIf="mainService.scope === 'RIS'"> IMMAGINI </button>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="btn2">
      <th mat-header-cell *matHeaderCellDef style="width:0;"></th>
      <td mat-cell *matCellDef="let row" style="width:0;"></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" [ngStyle]="{'text-align': 'center'}"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>
</div>

<!--
</div>
-->
